<script>
import {Message} from "element-ui";
import cityCodeData from '@/assets/city_code.json';
import {
  agentPage,
  createAgent,
  deleteAgentById,
  fetchOfficeUser,
  getAgentById,
  updateAgent
} from "@/api/user";
import {categoryTree} from "@/api";

export default {
  name: 'Agent',
  data() {
    return {
      isPlatformUser: true,
      cityTreeData: [],
      categories: [],
      filter : null,
      defaultProps: {
        children: 'children',
        label: 'value',
        value: 'code',
      },
      categoryProps: {
        children: 'child',
        label: 'name',
        value: 'id',
      },
      selectedPath: [],
      userList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      agentRole : {
        id : 2,
        code : 'agentRole',
        name : '代理商角色'
      },
      addVisible: false,
      agentForm: {
        cityPath: [],
        category: [],
        accountOpType: 'RELATION',
        bindType : 'REGION',
      },
      submitLoading : false,
    }
  },
  async mounted() {
    await this.checkIsPlatformUser()
    await this.loadCityData();
    this.fetchTopCategory();
    this.fetchAgentUserList();
  },
  methods: {
    // 校验是否平台用户
    checkIsPlatformUser() {
      const user = JSON.parse(localStorage.getItem('user'))
      this.isPlatformUser = user.sysAccount.officeId === 0
      console.log('this.isPlatformUser', this.isPlatformUser)
      if (!this.isPlatformUser) {
        Message.error({
          message: '非平台用户，访问失败',
          duration: 3000,
          onClose: () => {
            this.$router.push({name: 'dashboard'})
          }
        })

      }
      return Promise.resolve();
    },


    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchUserList()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchUserList()
    },
    // 加载城市代码数据
    async loadCityData() {
      try {
        this.cityTreeData = cityCodeData
      } catch (error) {
        console.error('加载城市数据失败:', error);
        Message.error('加载城市数据失败');
      }
    },

    changeCity(value) {
      this.agentForm.cityPath = value
    },


    addAgentUser() {
      this.addVisible = true;
    },

    async queryAccount(queryString, callback){
      if (queryString && queryString !== '') {
        const response = await fetchOfficeUser(queryString)
        if (response && response.result) {
          const accounts = response.result.map(item => ({
            'name': `${item.username}${item.mobileNo ? `  | ${item.mobileNo}` : ''}`,
            'id': Number(item.id)
          }))
          callback(accounts)
        } else {
          callback([])
        }
      }
    },

    async handleAccountSelect (val){
      this.agentForm.accountId = val.id;
      this.agentForm.accountName = val.name;
    },

    async fetchTopCategory(){
      const res = await categoryTree()
      if (res && res.code === "0000" && res.result && res.result.length > 0){
        this.categories = this.mergeCategoriesToChild(res.result) || []
      }
    },

    mergeCategoriesToChild(items) {
      return items.map(item => {
        const processedItem = { ...item };

        // 处理现有的child节点
        if (item.child && Array.isArray(item.child)) {
          processedItem.child = this.mergeCategoriesToChild(item.child);
        }

        // 将categories数组添加到child中
        if (item.categories && Array.isArray(item.categories) && item.categories.length > 0) {
          const categoriesAsChildren = item.categories.map(cat => ({
            ...cat,
            child: null  // categories项本身没有更深层级
          }));

          // 如果已有child，则合并；否则直接赋值
          if (processedItem.child && Array.isArray(processedItem.child)) {
            processedItem.child = [...processedItem.child, ...categoriesAsChildren];
          } else {
            processedItem.child = categoriesAsChildren;
          }
        }

        return processedItem;
      });
    },

    // 获取选中的第三层分类ID
    getSelectedThirdLevelCategories(paths) {
      const selectedPaths = paths.map(path => path.map(Number));
      const resultIds = [];
      selectedPaths.forEach(path => {
        if (path.length === 1) {
          // 如果选中的是第一层，获取其第二层的所有子分类ID
          const firstLevelId = path[0];
          const firstLevelCategory = this.findCategoryById(this.categories, firstLevelId);
          if (firstLevelCategory && firstLevelCategory.child) {
            firstLevelCategory.child.forEach(secondLevel => {
              if (secondLevel.child) {
                // 添加第二层下的所有第三层分类ID
                secondLevel.child.forEach(thirdLevel => {
                  resultIds.push(thirdLevel.id);
                });
              }
            });
          }
        } else if (path.length === 2) {
          // 如果选中的是第二层，获取其所有第三层子分类ID
          const [firstLevelId, secondLevelId] = path;
          const firstLevelCategory = this.findCategoryById(this.categories, firstLevelId);
          if (firstLevelCategory) {
            const secondLevelCategory = this.findCategoryById(firstLevelCategory.child, secondLevelId);
            if (secondLevelCategory && secondLevelCategory.child) {
              secondLevelCategory.child.forEach(thirdLevel => {
                resultIds.push(thirdLevel.id);
              });
            }
          }
        } else if (path.length === 3) {
          // 如果选中的是第三层，直接使用该ID
          resultIds.push(path[2]);
        }
      });

      return [...new Set(resultIds)]; // 去重并返回
    },

    // 辅助方法：根据ID查找分类
    findCategoryById(categories, id) {
      if (!categories || !Array.isArray(categories)) return null;

      for (const category of categories) {
        if (category.id === id) {
          return category;
        }
        if (category.child && category.child.length > 0) {
          const found = this.findCategoryById(category.child, id);
          if (found) return found;
        }
      }
      return null;
    },

    changeCategory(value) {
      this.agentForm.categoryIds = value;
      // 获取实际需要的第三层分类ID
      // const actualCategoryIds = this.getSelectedThirdLevelCategories(value);
      // // 可以将这些ID存储到表单中备用
      // this.agentForm.category = actualCategoryIds;
      // console.log('提取的第三层分类ID:', actualCategoryIds);
    },
    async addAgent(){
      this.submitLoading = true;
      try {
        const param = {
          ...this.agentForm,
          regionCodes : this.agentForm.cityPath,
          category:  this.getSelectedThirdLevelCategories(this.agentForm.categoryIds)
        }
        const res = param.id ?  await updateAgent(param) : await createAgent(param);
        if (res && res.code === "0000") {
          Message.success(`操作成功`);
          this.addVisible = false;
          await this.refreshAgentUserList();
        }

      }catch ( e){
        Message.error(`操作失败: ${e.message}`);
      }
      this.submitLoading = false;

    },

    async updateAndEnable(){
      const  category = this.getSelectedThirdLevelCategories(this.agentForm.categoryIds)
      const param = {
        ...this.agentForm,
        regionCodes : this.agentForm.cityPath,
        category,
      }
      const res = await updateAgent(param);
      if (res && res.code === "0000") {
        Message.success(`操作成功`);
        this.addVisible = false;
        await this.refreshAgentUserList();
      } else {
        Message.error(`操作失败: ${res.message}`);
      }
    },


    async handleSearch (){
      await this.refreshAgentUserList();
    },

    async refreshAgentUserList() {
      this.currentPage = 1;
      this.total = 0;
      this.userList = []
      await this.fetchAgentUserList();
    },

    // 查询代理用户
    async fetchAgentUserList() {
      const param = {
        current: this.currentPage,
        size: this.pageSize,
        filter : this.filter
      }
      const res = await agentPage(param);
      if (res && res.code === "0000") {
        this.userList = res.result.records || [];
        this.total = res.result.total;
      }
    },

    async handleEdit(id){
      const res = await getAgentById(id);
      if (res && res.code === "0000") {
        this.agentForm = res.result;
        this.agentForm.agentType = 'REGION';
        this.agentForm.cityPath = res.result.regionCodes;
        if (res.result.categoryIds && res.result.categoryIds.length > 0){
          this.agentForm.bindType = 'CATEGORY'
        }else if (res.result.regionCodes && res.result.regionCodes.length > 0){
          this.agentForm.bindType = 'REGION'
        }
      }
      this.addVisible = true;
    },

    handleCommand(command , data){
      switch (command){
        case 'delete' : {
          this.deleteAgent(data.agentId)
          break;
        }
      }
    },

    async deleteAgent(id){
      await deleteAgentById(id).then(res => {
        if (res && res.code === "0000") {
          Message.success(`操作成功`);
          this.refreshAgentUserList();
        }
      })
    },

    cleanAgentForm(){
      this.agentForm = {
        accountOpType: 'RELATION',
      }
    },

  },

}

</script>

<template>
  <div style="height: 100%; min-height: 0; overflow: hidden;">
    <el-empty v-if="!isPlatformUser">
      该账号非平台用户，访问失败
    </el-empty>
    <div v-else style="height:inherit">

      <el-card class="main-card">
        <div class="user-container" style="gap: 20px">
          <!-- 面包屑导航 -->
          <div class="header-container">
            <el-row :gutter="20" type="flex" align="center">
              <el-input size="small" v-model="filter" placeholder="搜索用户名/手机号/登录账号" style="width: 280px">
                <div slot="suffix" >
                  <el-button size="mini" type="text" icon="el-icon-search" @click="handleSearch" >搜索</el-button>
                </div>
              </el-input>
            </el-row>
            <el-button type="primary" @click="addAgentUser">添加代理</el-button>
          </div>

          <div class="table-container">

            <el-table :data="userList" border stripe highlight-current-row>
              <el-table-column prop="account" label="账号名" fixed min-width="120"/>
              <el-table-column prop="username" label="用户名" min-width="120"/>
              <el-table-column prop="gender" label="性别">
                <template slot-scope="scope">
                  <span>{{ scope.row.gender === 1 ? '男' : scope.row.gender === 0 ? '女' : '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="email" label="邮箱" show-overflow-tooltip/>
              <el-table-column prop="mobileNo" label="手机号"/>
              <el-table-column prop="available" label="是否生效">
                <template slot-scope="scope">
                  <span>{{ scope.row.available ? '是' : '否' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="baned" label="是否禁用">
                <template slot-scope="scope">
                  <span>{{ scope.row.baned ? '是' : '否' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="categoryIds" label="设备分类授权数" min-width="120">
                <template slot-scope="scope">
                  {{ scope.row.categoryIds ? scope.row.categoryIds.length : 0}}
                </template>
              </el-table-column>
              <el-table-column prop="regionCodes" label="地域授权数" min-width="120">
                <template slot-scope="scope">
                  {{ scope.row.regionCodes ? scope.row.regionCodes.length : 0}}
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" min-width="120" show-overflow-tooltip/>
              <el-table-column prop="updateTime" label="更新时间" min-width="120" show-overflow-tooltip/>

              <el-table-column label="操作" width="160" fixed="right">
                <template slot-scope="scope">
                  <el-button size="mini" type="text" @click="handleEdit(scope.row.agentId)">
                    编辑
                  </el-button>
                  <el-dropdown @command="(command) => handleCommand(command, scope.row)">
                    <el-button size="mini" type="text" style="margin-left: 10px; color: #4b5563;">
                      更多<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown" >
                      <el-dropdown-item command="delete" class="delete-btn">解除授权</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="table-footer">
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                             :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                             layout="total, sizes, prev, pager, next, jumper" :total="total"
                             class="pagination"/>
            </div>

            <el-dialog
                :title="`${agentForm.id ? '编辑' : '新增'}代理`" :visible.sync="addVisible" width="60%"
                @close="cleanAgentForm"
            >
              <el-row type="flex" :gutter="20">
                <el-col :span="12" v-if="!agentForm.id">
                  <el-card shadow="never">
                    <el-form :model="agentForm">
                      <el-form-item prop="id"  />
                      <el-form-item prop="accountOpType">
                        <el-radio-group v-model="agentForm.accountOpType">
                          <el-radio label="RELATION">关联企业用户</el-radio>
                          <el-radio label="CREATE">增加新用户</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <div v-if="agentForm.accountOpType === 'RELATION'" >
                        <el-form-item prop="accountId" label="企业用户">
                          <el-autocomplete
                              v-model="agentForm.accountName"
                              :fetch-suggestions="queryAccount"
                              placeholder="请输入用户名/账号名/手机号"
                              :trigger-on-focus="false"
                              @select="handleAccountSelect"
                              clearable
                              value-key="id"
                              style="width: 100%"
                              suffix-icon="el-icon-search"
                          >
                            <div slot-scope="{ item }">
                              <span>{{ item.name }}</span>
                            </div>
                          </el-autocomplete>
                        </el-form-item>
                      </div>
                      <div v-else>
                        <el-form-item required label="登录用户名" prop="account">
                          <el-input v-model="agentForm.account" placeholder="请输入用户名"/>
                        </el-form-item>
                        <el-form-item required label="登录密码">
                          <el-input v-model="agentForm.password" placeholder="请输入密码"/>
                        </el-form-item>
                        <el-form-item required label="代理商名称">
                          <el-input v-model="agentForm.agentName" placeholder="请输入代理商名称"/>
                        </el-form-item>
                      </div>
                    </el-form>
                  </el-card>
                </el-col>
                <el-col :span="24">
                    <el-card shadow="never" style="height: 100% ;flex: 1">
                      <el-form label-width="120px" :model="agentForm">
                        <el-tabs v-model="agentForm.bindType" >
                          <el-tab-pane label="城市层级" name="REGION">
                            <el-form-item label="城市层级" prop="cityPath">
                              <el-cascader
                                  v-model="agentForm.cityPath"
                                  :options="cityTreeData"
                                  :props="{ expandTrigger: 'hover', checkStrictly: true,  multiple: true , ...defaultProps}"
                                  placeholder="搜索/选择城市层级"
                                  filterable
                                  clearable
                                  @change="changeCity"
                                  style="width: 60%"
                              />
                            </el-form-item>

                          </el-tab-pane>
                          <el-tab-pane label="设备分类" name="CATEGORY">
                            <el-form-item label="设备分类" prop="category"  style="width: 100%">
                              <el-cascader
                                  v-model="agentForm.categoryIds"
                                  :options="categories"
                                  :props="{ expandTrigger: 'hover', checkStrictly: true,  multiple: true , ...categoryProps}"
                                  placeholder="搜索/选择城市层级"
                                  filterable
                                  clearable
                                  @change="changeCategory"
                                  style="width: 60%"
                              />
                          </el-form-item>

                          </el-tab-pane>
                        </el-tabs>
                      </el-form>
                    </el-card>
                </el-col>
              </el-row>

              <el-row type="flex" justify="end" style="margin-top: 10px;">
                <el-button v-if="!agentForm.id" type="primary" @click="addAgent" :disabled="submitLoading" :loading="submitLoading">立刻提交</el-button>
                <el-button v-if="agentForm.id" type="primary" @click="updateAndEnable" :disabled="submitLoading" :loading="submitLoading">提交且生效权限</el-button>
              </el-row>

            </el-dialog>
          </div>
        </div>
      </el-card>
    </div>
  </div>

</template>

<style scoped>
@import "../../styles/panel.css";

.main-card {
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: none;
  overflow: hidden;
  transition: all 0.3s ease;
}

.main-card:hover {
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}

.user-container {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 10px;
}

.table-container {
  flex: 1;
  min-height: 0;
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .table-footer {
    display: flex;
    justify-content: flex-end;
  }
}

</style>
